module.exports = __webpack_public_path__ + "static/logo-b79d69dbee72ef94463fbebecafc3682.png";